import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

// 卡牌系列接口
export interface CardSeries {
  id: number;
  name: string;
  image: string | null;
  description: string | null;
  enabled: boolean;
  sort: number;
  cards_count?: number;
  card_pools_count?: number;
  created_at: string;
  updated_at: string;
  updated_by?: string;
}

// 下拉选项接口
export interface CardSeriesOption {
  id: number;
  name: string;
}

@Module
export default class CardSeriesModule extends VuexModule {
  card_series_list = [] as Array<CardSeries>;
  card_series_count = 0;
  card_series = {} as CardSeries;
  all_card_series = [] as Array<CardSeriesOption>;

  get currentCardSeriesList(): Array<CardSeries> {
    return this.card_series_list;
  }

  get currentCardSeries(): CardSeries {
    return this.card_series;
  }

  get currentCardSeriesCount(): number {
    return this.card_series_count;
  }

  get currentAllCardSeries(): Array<CardSeriesOption> {
    return this.all_card_series;
  }

  @Mutation
  [Mutations.SET_CARD_SERIES_LIST](card_series_list: Array<CardSeries>) {
    this.card_series_list = card_series_list;
  }

  @Mutation
  [Mutations.SET_CARD_SERIES](card_series: CardSeries) {
    this.card_series = card_series;
  }

  @Mutation
  [Mutations.SET_CARD_SERIES_COUNT](count: number) {
    this.card_series_count = count;
  }

  @Mutation
  [Mutations.SET_ALL_CARD_SERIES](all_card_series: Array<CardSeriesOption>) {
    this.all_card_series = all_card_series;
  }

  @Action
  [Actions.GET_CARD_SERIES_LIST](params: Record<string, unknown>) {
    ApiService.setHeader();

    let queryString = "?";
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          queryString += "&" + key + "=" + params[key];
        }
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/card_series", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CARD_SERIES_LIST, data["card_series_list"] || data["card_series"]);
          this.context.commit(Mutations.SET_CARD_SERIES_COUNT, data["total_result"] || 0);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.GET_CARD_SERIES](id: number) {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.get(`admin/card_series/${id}`)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CARD_SERIES, data["card_series"]);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.CREATE_CARD_SERIES](params: Record<string, unknown>) {
    ApiService.setHeader();

    return new Promise<{ success: boolean; error_msg?: string }>((resolve, reject) => {
      ApiService.post("admin/card_series", { card_series: params })
        .then(({ data }) => {
          if (data.success) {
            this.context.commit(Mutations.SET_CARD_SERIES, data["card_series"]);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject(response?.data);
        });
    });
  }

  @Action
  [Actions.UPDATE_CARD_SERIES](credentials: { id: number; values: Record<string, unknown> }) {
    ApiService.setHeader();

    return new Promise<{ success: boolean; error_msg?: string }>((resolve, reject) => {
      ApiService.put(`admin/card_series/${credentials.id}`, { card_series: credentials.values })
        .then(({ data }) => {
          if (data.success) {
            this.context.commit(Mutations.SET_CARD_SERIES, data["card_series"]);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject(response?.data);
        });
    });
  }

  @Action
  [Actions.DELETE_CARD_SERIES](id: number) {
    ApiService.setHeader();

    return new Promise<{ success: boolean; error_msg?: string }>((resolve, reject) => {
      ApiService.delete(`admin/card_series/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject(response?.data);
        });
    });
  }

  @Action
  [Actions.GET_ALL_CARD_SERIES]() {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/card_series/all")
        .then(({ data }) => {
          this.context.commit(Mutations.SET_ALL_CARD_SERIES, data["card_series"] || []);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }
}
